import React, { FC, Fragment } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { useLocation, useNavigate } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { TransferRequestType } from 'models/transfer-request.model';
import TransferStatusTag from 'components/base/transfer-status-tag';
import { formatRequestDate } from 'utils/functions';
import {
  buildTransferRoute,
  getTransferStoreTypeFromPathname,
  normalizeTransferStoreType
} from 'pages/main-store/transfer/store-type';

type Props = {
  request: TransferRequestType;
};

const TransferRequestCard: FC<Props> = ({ request }) => {
  const orderCode = request?.code;
  const { stores } = useDashboardContext();
  const router = useNavigate();
  const location = useLocation();
  const storeType = normalizeTransferStoreType(getTransferStoreTypeFromPathname(location.pathname));

  const viewRequest = () => {
    router(buildTransferRoute(storeType, `update/${request.id}`));
  };
  return (
    <Fragment>
      <div className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2 w-full'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium text-base cursor-pointer'>#{orderCode}</h4>
            <TransferStatusTag type={request?.status} />
          </div>
          <div className='p-3'>
            <div className='flex gap-2 text-sm text-gray-5'>
              <span className=''> From</span>{' '}
              <p>{stores.find((store) => store.id === request?.from_store_id)?.name} </p>
              <p className='capitalize font-[500]'>
                to {request.transfer_type.split('_').map((item) => item.toLowerCase())}
              </p>
            </div>
            <div className=' text-sm'>
              {request?.items?.map((item, i) => (
                <div key={i} className='flex  items-center '>
                  <p>{item.ingredient.name} </p>
                  <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px] rounded-full' />
                  <p className='text-sm text-gray-5'>
                    {item.quantity} {item.ingredient.unit_type || 'portions'}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <div className='flex gap-2'>
            <p>Created {formatRequestDate(request.created_at)}</p>
          </div>

          <Button className='text-xs' color='primary' variant='link' onClick={() => viewRequest()}>
            See all
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default TransferRequestCard;
